module.exports = __webpack_public_path__ + "static/media/IMG_9038.84804fc5.JPG";